/**
 * Single source of truth for page hero imagery.
 *
 * Routes pull their hero photo from here, and the menu popout reuses the same
 * entries for its image panel — so updating a hero here updates it everywhere.
 */

export type HeroEntry = {
  /** Hero background photo (public path). */
  image: string;
  /** Default hero title for the route. */
  title: string;
};

export const heroes = {
  "/": { image: "/media/loli-slider-1.jpg", title: "Light of Life International" },
  "/about": { image: "/media/about-hero-selfie.jpg", title: "About Us" },
  "/crusades": { image: "/media/loli-crusades-hero.jpg", title: "Crusades" },
  "/blog": { image: "/media/vol_07-1.jpg", title: "Blog" },
  "/donate": { image: "/media/donate-hero-van.jpg", title: "Donate" },
  "/join-us": { image: "/media/join-us-hero-group.jpg", title: "Join Us" },
  "/contact": { image: "/media/loli-style-guide-hero.jpg", title: "Contact" },
  "/fire-carriers": { image: "/media/fire-carriers-hero.jpg", title: "Fire Carriers" },
  "/fire-starters-and-rain-crusaders": {
    image: "/media/fire-starters-and-rain-crusaders-hero.jpg",
    title: "Fire Starters and Rain Crusaders",
  },
  "/donation-form": { image: "/media/vol_01-1.jpg", title: "Donation Form" },
  "/donation-form/monthly-recurring": { image: "/media/vol_01-1.jpg", title: "Monthly Recurring" },
  "/privacy-policy": { image: "/media/vm06.webp", title: "Privacy Policy" },
  "/thank-you": { image: "/media/vm08.webp", title: "Thank You" },
} as const satisfies Record<string, HeroEntry>;

export type HeroRoute = keyof typeof heroes;

export const fallbackHero: HeroEntry = {
  image: "/media/LOLI_Crusades_22.jpg",
  title: "Light of Life International",
};

/** Hero entry for a pathname, falling back to a shared default photo. */
export function heroFor(path: string): HeroEntry {
  const normalized = path !== "/" && path.endsWith("/") ? path.slice(0, -1) : path;
  return (heroes as Record<string, HeroEntry>)[normalized] ?? fallbackHero;
}
